<template>
<div>



<div class="contenttopbar grid px-3 mt-1">

<div class="col-9 md:col-8">
<h3 class="text-primary mb-3 mt-3 font-medium">{{$store.state.languages.lang_phrases.marka_ozel_nitelikleri}}</h3>
</div>

<div class="col-3 md:col-4">
<div class="flex align-items-center justify-content-end">

<div class="hide_on_mobile "><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2 mr-2" :label="$store.state.languages.lang_phrases.yeni_grup_ekle" icon="pi pi-sitemap" @click="addNewGroup" /></div>
<div class="show_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2 mr-2" icon="pi pi-sitemap" @click="addNewGroup" /></div>

<div class="hide_on_mobile "><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2" :label="$store.state.languages.lang_phrases.yeni_ekle" icon="pi pi-plus" @click="addNew" /></div>
<div class="show_on_mobile"><Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2" icon="pi pi-plus" @click="addNew" /></div>


</div>
</div>
</div>  




<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">

<!--groups-->
<div class="grid py-0">
<div class="col-12 pb-0"><h3 class="text-primary mt-4 mb-0">Özel Nitelik Grupları</h3></div>
<div class="col-12"><hr></div>

<div class="col-12 " v-if="!groups.length">
<div class="flex align-items-center justify-content-center mb-2 mt-2">
<h3 class="text-primary font-medium">{{$store.state.languages.lang_phrases.henuz_hic_kayit_olusturulmamis}}</h3>
</div>
</div>

<div class="col-12 " v-else>
<draggable 
v-model="groups"
data_container_id="groups"
class="list-group" 
group="grouped"  
@change="changeGroups"
v-bind="dragOptions"
item-key="id"> 
<template #item="{element}">
<CustomAttributeGroupLine :group="element" @groupdeleted="groupdeleted"/>
</template>
</draggable>

</div>


</div>
<!--groups-->


<template v-if="items.length==0">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">{{$store.state.languages.lang_phrases.henuz_hic_kayit_olusturulmamis}}</h3>

</div>
</template>
<template v-else>
<hr>
<h3 class="text-primary mt-4 mb-0">{{$store.state.languages.lang_phrases.gruplanmis_ozel_nitelikler}}</h3>
<draggable 
v-model="items"
data_container_id="ungrouped"
class="list-group" 
group="ungrouped" 
@start="start" 
@end="end" 
@change="change"
v-bind="dragOptions"
item-key="id">
<template #item="{element}">
<CustomAttributeLine :attribute="element" />
</template>
</draggable>

<!--
  <ContentTable :data="items" :columns="columns" identifier_row_name="attribute_id" routename="BrandCustomAttribute" deleteobjectname="custom_attribute" @dataDeleted="getData"></ContentTable>
-->

</template>

</template>

</div>
</template>
<script>
export default {

  name: 'BrandCustomAttributes',

  data () {
    return {
      items:[],
      groups:[],
      loading:true,
      drag:false,
      columns:[
        {
          type:"text",
          field:"name",
          header:"isim",
          hide_on_mobile:false,
          multilingual:true,
        },
        {
          type:"text",
          field:"type",
          header:"tur",
          hide_on_mobile:true,
        },
      ]
    }
  },
   mounted()
  {
    this.getData()
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods:{
    groupdeleted(id)
    {
      this.renewData()
    },
    changeGroups()
    {
      let formdata = new FormData()
      let list = this.groups.map(item=>item.id)
      formdata.append("list",JSON.stringify(list))
      this.silentSubmission(formdata,"custom_attributes/reorder_attribute_groups",this.afterChange)
    },
    change(event)
    {
      console.log("ungrouped")
      console.log(this.items)
      let formdata = new FormData()
      let list = this.items.map(item=>item.id)
      formdata.append("list",JSON.stringify(list))
      this.silentSubmission(formdata,"custom_attributes/reorder_group_attributes/ungrouped",this.afterChange)

    },
    afterChange(response)
    {

    },
    end(event)
    {
      this.drag = false
    },
    start(event)
    {
      this.drag = true
    },
    addNew()
    {
      this.$router.push({ name: "CreateBrandCustomAttribute"})
    },
    addNewGroup()
    {
      this.$router.push({ name: "CreateBrandCustomAttributeGroup"})
    },
    async renewData()
    {
      this.items = await this.generalApiGetWithoutLoader("custom_attributes/ungrouped_brand_attributes/"+this.$route.params.id)
      this.groups = await this.generalApiGetWithoutLoader("custom_attributes/brand_attribute_groups/"+this.$route.params.id)
    },
    async getData()
    {
        this.items = await this.generalApiGetWithoutLoader("custom_attributes/ungrouped_brand_attributes/"+this.$route.params.id)
        this.groups = await this.generalApiGetWithoutLoader("custom_attributes/brand_attribute_groups/"+this.$route.params.id)

        
        console.log(this.items)
        console.log(this.groups)
        this.loading = await false
    },    
  }
}
</script>

<style lang="css" scoped>
</style>